import { useParams, useNavigate } from "react-router-dom";

const BlogDetails = ({ blogs, setBlogs }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const blog = blogs.find((b) => b.id === Number(id));

  const handleClick = () => {
    setBlogs((prevBlogs) => prevBlogs.filter((b) => b.id !== Number(id)));
    navigate("/");
  };

  return (
    <div className="blog-details">
      {!blog && <div>Loading...</div>}
      {blog && (
        <article>
          <h2>{blog.title}</h2>
          <p>Written by {blog.author}</p>
          <div>{blog.body}</div>
          <button onClick={handleClick}>Delete</button>
        </article>
      )}
    </div>
  );
};

export default BlogDetails;
